import { getSiteProps } from "@/utils/siteProps";

export const countries = [
  {
    id: "1",
    value: "//www.foundit.in",
    name: "India",
  },
  {
    id: "2",
    value: "//www.founditgulf.com",
    name: "Gulf",
  },
  {
    id: "3",
    value: "//www.foundit.hk",
    name: "Hong Kong",
  },
  {
    id: "4",
    value: "//www.foundit.sg",
    name: "Singapore",
  },
  {
    id: "5",
    value: "//www.foundit.com.ph",
    name: "Philippines",
  },
  {
    id: "6",
    value: "//www.monster.co.th",
    name: "Thailand",
  },
  {
    id: "7",
    value: "//www.monster.com.vn",
    name: "Vietnam",
  },
  {
    id: "8",
    value: "//www.foundit.id",
    name: "Indonesia",
  },
  {
    id: "9",
    value: "//www.foundit.my",
    name: "Malaysia",
  },
];

export const downloadBanners = (host: string) => {
  const siteProps = getSiteProps(host); // TODO
  const mediaURL = siteProps?.media_url;

  return [
    {
      imgURL: `https://${mediaURL}/public/core/images/appstore.svg`,
      link_rewrite: "https://apps.apple.com/in/app/monster-jobs/id525775161",
      imageName: "IOS Download",
    },
    {
      imgURL: `https://${mediaURL}/public/core/images/playstore.svg`,
      link_rewrite:
        "https://play.google.com/store/apps/details?id=com.monsterindia.seeker.views",
      imageName: "Android Download",
    },
  ];
};
